import React from "react";
import borderRightImg from "../../assets/images/webp/other/border-right.webp";

const WaterHold = () => {
  return (
    <>
      <div className="bg-center bg-cover bg-no-repeat px-4 bg-water-hold-bg flex items-center justify-center">
        <div className="flex items-center flex-col justify-center py-[217px] max-xl:py-32 max-lg:py-20 max-md:py-16 max-sm:py-10">
          <h2 className="text-center text-white max-w-[816px] mx-auto ff-jakarta text-6xl max-xl:text-[50px] max-lg:text-5xl max-md:text-4xl max-sm:text-3xl font-bold leading-[120%]">
            Water holds memory. Now it holds your destiny
          </h2>
          <div className="flex items-center gap-[22px] mt-10 max-w-[252px] mx-auto w-full justify-between">
            <img
              src={borderRightImg}
              width={4}
              height={27}
              alt="line"
              className="h-[27px]"
            />
            <p className="text-[#FAFAFA] text-[28px] whitespace-nowrap ff-helvetica font-medium leading-[145%] ">
              Deepak Sharma
            </p>
            <img
              src={borderRightImg}
              width={4}
              height={27}
              alt="line"
              className="h-[27px]"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default WaterHold;
